import * as yup from "yup";
import { validationConfirmNewPasswordL, validationNewPassword, validationNotEmpty } from "./defaultValidations";

export default yup.object({
    oldPassword: validationNotEmpty("Old Password"),
    password: validationNewPassword("Password"),
    confirmPassword: validationConfirmNewPasswordL("Confirm Password"),
});